enum CurrencyCode {
	USD = 'USD',
	EUR = 'EUR',
}

export default CurrencyCode;
